// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1I-Pj","errors":"Errors_errors__2gSe3"};